import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { SituacionEducativa } from '@shared/models';
import { ResponseWrapper } from '@shared';
import { environment } from '@env';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_SITUACION_EDUCATIVA = '/situacion-educativa';

@Injectable({
  providedIn: 'root',
})
export class SituacionEducativaService {
  private readonly API_URL_SITUACION_EDUCATIVA = API_URL + ENDPOINT_SITUACION_EDUCATIVA;
  private http = inject(HttpClient);

  listarSituacionEducativa(): Observable<SituacionEducativa[]> {
    return this.http
      .get<ResponseWrapper<SituacionEducativa[]>>(this.API_URL_SITUACION_EDUCATIVA)
      .pipe(
        map((res) => {
          return res.data;
        }),
      );
  }
}
